import { Link } from "react-router-dom";
import { CITY_PAGES } from "@/data/cities";
import { MapPin } from "lucide-react";
import SEO from "@/components/SEO";

export default function Locations() {
  // Group by region
  const grouped = CITY_PAGES.reduce((acc, c) => {
    acc[c.region] = acc[c.region] || [];
    acc[c.region].push(c);
    return acc;
  }, {});

  return (
    <div data-testid="locations-page">
      <SEO
        title="Texas Locations — Independent Environmental Assessments"
        description="Hurtler Environmental serves 25+ Texas cities across the Rio Grande Valley, Coastal Bend, South Central Texas, Gulf Coast, and beyond. Headquartered in Edinburg."
        path="/locations"
      />
      <section className="bg-[#0F172A] text-white py-24">
        <div className="container-x">
          <div className="overline text-[#F59E0B] mb-5">Texas locations</div>
          <h1 className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight leading-[1.05] max-w-4xl">
            Headquartered in <span className="text-[#F59E0B]">Edinburg.</span> Serving Texas.
          </h1>
          <p className="mt-8 text-lg text-white/70 max-w-2xl leading-relaxed">
            From the Rio Grande Valley to the Coastal Bend, San Antonio, Austin, and beyond — we
            deploy scientific environmental assessment services where Texans need them.
          </p>
        </div>
      </section>

      <section className="section-pad bg-white">
        <div className="container-x space-y-16">
          {Object.entries(grouped).map(([region, cities]) => (
            <div key={region} data-testid={`region-${region.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="overline mb-5">{region}</div>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                {cities.map((c, i) => (
                  <Link
                    key={c.slug}
                    to={`/locations/${c.slug}`}
                    data-testid={`location-link-${c.slug}`}
                    className="card-soft p-6"
                  >
                    <MapPin className="w-5 h-5 text-[#7C3AED] mb-3" />
                    <div className="font-display font-bold text-[#0F172A]">{c.name}</div>
                    <div className="text-xs text-slate-500 uppercase tracking-wider mt-1">
                      {c.isHQ ? "Headquarters" : c.county}
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
